import { render, staticRenderFns } from "./admin_nav.vue?vue&type=template&id=6f1dc826"
import script from "./admin_nav.vue?vue&type=script&lang=js"
export * from "./admin_nav.vue?vue&type=script&lang=js"
import style0 from "./admin_nav.vue?vue&type=style&index=0&id=6f1dc826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports